export default "__VITE_ASSET__BvBjzv_q__"